import * as request from '@/utils/request'

/**
 * 列表
 * @param data
 * @returns {Promise}
 */
export function brandDataMonth(data) {
  return request.post('/ad_system/brand_data_month', data)
}

/**
 *
 * @param data
 * @return {Promise}
 */
export function brandDataMonthTrades(data) {
  return request.post('/ad_system/brand_data_month_trades', data)
}
